<template>
  <router-view></router-view>
</template>

<script>
  import {SET_LOGOUT} from "@/store/auth/mutations";
  import {ROUTE_NAMES_AUTH} from "@/router/modules/auth";
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";

  export default {
    name: 'Logout',
    setup() {
      const store = useStore();
      const router = useRouter();

      store.commit(SET_LOGOUT);
      router.push({name: ROUTE_NAMES_AUTH.LOGIN});
    }
  }
</script>

<style scoped lang="scss">
</style>
